export default __webpack_public_path__ + "static/give-gift-card-468851e811b4a714f08b3a91f7cd3f66.png";